import ganttChartInit from '../theme/ganttchart/gantt-chart';

const { docReady } = window.phoenix.utils;

docReady(ganttChartInit);
